import {PayMethod, PayMethodType} from '@web/core/constants'

/** 우선순위에 따른 복합결제 결제수단을 반환합니다. */
function getNextPayMethodByComplexPayment({
    availablePayMethodTypes,
    hasCardEasyPays,
}: {
    // 사용 가능한 결제 수단 타입
    availablePayMethodTypes: PayMethodType[]
    // 카드 간편결제 수단
    hasCardEasyPays: boolean
}): PayMethodType {
    if (availablePayMethodTypes.includes(PayMethod.CARD_EASY_PAY) && hasCardEasyPays) {
        return PayMethod.CARD_EASY_PAY
    } else if (availablePayMethodTypes.includes(PayMethod.BANK_EASY_PAY)) {
        return PayMethod.BANK_EASY_PAY
    } else if (availablePayMethodTypes.includes(PayMethod.CARD)) {
        return PayMethod.CARD
    } else if (availablePayMethodTypes.includes(PayMethod.MOBILE)) {
        return PayMethod.MOBILE
    } else if (availablePayMethodTypes.includes(PayMethod.VIRTUAL_ACCOUNT)) {
        return PayMethod.VIRTUAL_ACCOUNT
    }
    return PayMethod.NONE
}

/** 현재 선택 결제수단으로 결제시 당장 외부로 결제요청이 일어날 것인지 여부 */
function isActualPaymentTransactionEnabled(selectedPayMethod: PayMethodType) {
    switch (selectedPayMethod) {
        case PayMethod.REWARD_POINT:
        case PayMethod.CHARGE_POINT:
        case PayMethod.RECHARGE_POINT:
        case PayMethod.PAY_LATER:
        case PayMethod.SKIP:
        case PayMethod.NONE:
            return false
        default:
            return true
    }
}

export default {
    getNextPayMethodByComplexPayment,
    isActualPaymentTransactionEnabled,
}
